import React, { FunctionComponent } from 'react'

interface ProductCardProps {
  title: string
  link?: string
  thumbnail: boolean
  url: string
}

export const ProductCard: FunctionComponent<ProductCardProps> = (props) => {
  const { title, thumbnail, url } = props || {}

  return (
    <div className="productCard-wrapper">
      <a
        href={url}
        data-testid="productCard-url"
        target="_blank"
        rel="noreferrer"
        style={{ color: 'black' }}
      >
        {thumbnail && (
          <img
            style={{ paddingRight: '5px' }}
            src="https://www.paypalobjects.com/docsvideoassets/PP-logo.svg"
            alt="PayPal Logo"
          />
        )}
        {title}
      </a>
    </div>
  )
}
